
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 141.293 141.293"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M77.955 109.975a7.31 7.31 0 000 14.618h56.029a7.308 7.308 0 007.309-7.31 7.308 7.308 0 00-7.309-7.308H77.955zM0 44.2a7.308 7.308 0 007.309 7.308h19.489v19.49a7.308 7.308 0 1014.617 0v-19.49H63.34a7.307 7.307 0 007.308-7.308 7.308 7.308 0 00-7.308-7.309H41.414V12.53a7.308 7.308 0 00-7.309-7.308 7.307 7.307 0 00-7.308 7.308v24.361H7.308A7.31 7.31 0 000 44.2zM131.428 17.261a7.307 7.307 0 00-10.336 0L14.763 123.594a7.308 7.308 0 000 10.334 7.277 7.277 0 005.167 2.143 7.287 7.287 0 005.169-2.143L131.428 27.599a7.31 7.31 0 000-10.338z"}})])
          )
        }
      }
    